module.exports = __webpack_public_path__ + "static/media/404.cca9d46d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/NotFound/404.svg
// module id = 636
// module chunks = 0